import { Injectable, inject } from '@angular/core';
import * as joint from '@clientio/rappid';
import { TranslocoService } from '@jsverse/transloco';

import { SelectionBehavior } from '@treetop/shared/model';

import { LinkAnchorData } from './operations.service';
import { PortsService } from './ports.service';
import { PositionService } from './position.service';
import { FlowchartConfig } from '../base/flowchart.config';
import { SelectionBehaviorElement } from '../shapes/selection-behavior';

@Injectable({
  providedIn: 'root',
})
export class SelectionBehaviorNodeService {
  private translocoService = inject(TranslocoService);
  private positionService = inject(PositionService);

  createSelectionBehaviorNode(
    paper: joint.dia.Paper,
    selectionBehavior: SelectionBehavior,
    x: number,
    y: number,
    id?: string,
    allowEvents?: boolean,
  ): joint.dia.Cell {
    const text = this.translocoService.translate(SelectionBehavior[selectionBehavior]);
    const node = new SelectionBehaviorElement(
      {
        position: { x, y },
      },
      allowEvents,
    );

    node.setText(text);

    if (id) {
      node.set('id', id);
    }
    node.set('isSelectionBehavior', true);

    PortsService.addPorts(node);
    return node;
  }

  createSelectionBehaviorNodeInDefaultPosition(
    paper: joint.dia.Paper,
    sourceElement: joint.dia.ElementView,
    sourceAnchor: LinkAnchorData,
    overwrittenPosition?: joint.g.PlainPoint,
  ): joint.dia.Cell {
    if (overwrittenPosition) {
      return this.createSelectionBehaviorNode(paper, SelectionBehavior.And, overwrittenPosition.x, overwrittenPosition.y, null, true);
    }

    const selectionBehaviorPosition = this.positionService.calculateStepPosition(
      sourceElement.model.attributes.size,
      sourceElement.model.attributes.position,
      sourceAnchor,
      FlowchartConfig.selectionBehaviorNode.size,
    );

    const { gridSize } = FlowchartConfig.paper;

    if (selectionBehaviorPosition.y % gridSize === 0) {
      const { height } = FlowchartConfig.selectionBehaviorNode.size;
      selectionBehaviorPosition.y = selectionBehaviorPosition.y - (height - gridSize * 2) / 2;
    }

    return this.createSelectionBehaviorNode(
      paper,
      SelectionBehavior.And,
      selectionBehaviorPosition.x,
      selectionBehaviorPosition.y,
      null,
      true,
    );
  }
}
